/* eslint-disable react/prop-types */
import * as React from 'react';

import { Paper, Button, makeStyles } from '@material-ui/core';

import CommentInput from './commentInput';
import { useSelector } from 'react-redux';
import CommentList from './commentsList';
import { useTranslation } from 'react-i18next';
import { selectLoggedInUser } from 'store/user/selectors.js/user.selectors';

const useStyles = makeStyles((theme) => ({
  root: {},
  framePaper: {
    //...theme.component.commentSecondary,
    background: 'rgba(33, 168, 224,0.3)',
    // ...theme.component.drawerPaper,
    width: '100%',
    height: '100%',
    position: 'relative',
    padding: '4px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: '6px',
  },

  framePaperOverlay: {
    flex: '1 1 auto',
    minHeight: 0,
    height: 'auto',
    maxHeight: '100%',
    background: 'transparent',
    boxShadow: 'none',
    justifyContent: 'flex-end',
    pointerEvents: 'none',
  },

  commentList: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    maxHeight: '100%',
  },
  commentListOverlay: {
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: '100%',
  },

  imageThumbnail: {
    width: '40px',
    height: '40px',
  },

  gridContainer: {
    height: '100%',
  },
  commentText: {
    paddingLeft: '4px',
    fontSize: '14px',
    margin: '0px',
    width: '100%',
    overflowWrap: 'break-word',
  },
  alignSelf: {
    position: 'absolute',
    top: '2%',
    left: '1%',
  },
  overlayToggle: {
    ...theme.typography.fontPantonSemiBold,
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    textTransform: 'none',
    fontSize: '0.8rem',
    padding: '2px 8px',
    margin: '0 2px',
    color: '#fff',
    background: 'rgba(0,0,0,0.55)',
    pointerEvents: 'auto',
    '&:hover': {
      background: 'rgba(0,0,0,0.7)',
    },
  },
}));

const COLLAPSED_COMMENT_COUNT = 3;

export default function CommentsSection({
  comments,
  handleCreateComment,
  overlay,
  // Drawn over the photo only (`overlay`), between the "show all" toggle and
  // the input: the photo viewer's row of media tags on a phone.
  overlayAccessory,
}) {
  const classes = useStyles();

  const user = useSelector(selectLoggedInUser);
  const { t } = useTranslation();

  const [showAll, setShowAll] = React.useState(false);

  const allComments = comments || [];
  const hasMore = overlay && allComments.length > COLLAPSED_COMMENT_COUNT;
  // Comments render newest-first (column-reverse), so slice from the start
  // to keep the latest few when collapsed.
  const visibleComments =
    overlay && !showAll
      ? allComments.slice(0, COLLAPSED_COMMENT_COUNT)
      : allComments;

  return (
    <Paper
      className={`${classes.framePaper} ${
        overlay ? classes.framePaperOverlay : ''
      }`}
    >
      {overlay || (comments && comments.length > 0) ? null : (
        <div className={classes.alignSelf}>
          <p className={classes.commentText}>{t('gallery.no_comments')}.</p>
        </div>
      )}

      <div
        className={`${classes.commentList} ${
          overlay ? classes.commentListOverlay : ''
        }`}
      >
        <CommentList
          comments={visibleComments}
          user={user}
          overlay={overlay}
        ></CommentList>

        {hasMore && (
          <Button
            className={classes.overlayToggle}
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? t('gallery.show_less') : t('gallery.show_all_comments')}
          </Button>
        )}

        {overlay ? overlayAccessory : null}

        <CommentInput
          handleCreateComment={handleCreateComment}
          overlay={overlay}
        ></CommentInput>
      </div>
    </Paper>
  );
}
